import { __extends } from "tslib";
import { URLLoader as URLLoaderAway, URLLoaderEvent } from '@awayjs/core';
import { EventDispatcher } from '../events/EventDispatcher';
import { Event } from '../events/Event';
import { ProgressEvent } from '../events/ProgressEvent';
import { IOErrorEvent } from '../events/IOErrorEvent';
import { matchRedirect } from '@awayfl/swf-loader';
import { URLLoaderDataFormat } from './URLLoaderDataFormat';
var URLLoader = /** @class */ (function (_super) {
    __extends(URLLoader, _super);
    function URLLoader() {
        var _this = _super.call(this) || this;
        _this._dataIsNull = true;
        _this._adaptee = new URLLoaderAway();
        _this._completeCallbackDelegate = function (event) { return _this.completeCallback(event); };
        _this._progressCallbackDelegate = function (event) { return _this.progressCallback(event); };
        _this._loadErrorDelegate = function (event) { return _this.loadErrorDelegate(event); };
        _this.eventMapping[Event.COMPLETE] = {
            adaptedType: URLLoaderEvent.LOAD_COMPLETE,
            addListener: _this.initListener,
            removeListener: _this.removeListener,
            callback: _this._completeCallbackDelegate
        };
        _this.eventMapping[ProgressEvent.PROGRESS] = {
            adaptedType: URLLoaderEvent.LOAD_PROGRESS,
            addListener: _this.initListener,
            removeListener: _this.removeListener,
            callback: _this._progressCallbackDelegate
        };
        _this.eventMapping[IOErrorEvent.IO_ERROR] = {
            adaptedType: URLLoaderEvent.LOAD_ERROR,
            addListener: _this.initListener,
            removeListener: _this.removeListener,
            callback: _this._loadErrorDelegate
        };
        Object.defineProperty(_this, '$Bgdata', {
            get: _this.getData.bind(_this),
            set: _this.setData.bind(_this)
        });
        return _this;
    }
    URLLoader.prototype.close = function () {
        console.log('not mimplemented: URLoader.close');
    };
    URLLoader.prototype.setData = function (v) {
        this._dataIsNull = this._dataIsNull || v === null;
    };
    // trait not have data as get/set, we should redefine it in constructor
    URLLoader.prototype.getData = function () {
        if (this._dataIsNull)
            return null;
        var rawData = this._adaptee.data;
        switch (this.$BgdataFormat) {
            case URLLoaderDataFormat.VARIABLES: {
                return new this.sec.flash.net.URLVariables(rawData);
            }
            case URLLoaderDataFormat.BINARY: {
                console.warn('[URLLoader] Binary not supported');
                return null;
            }
            default: {
                return rawData;
            }
        }
    };
    URLLoader.prototype.initListener = function (type, callback) {
        this._adaptee.addEventListener(type, callback);
    };
    URLLoader.prototype.removeListener = function (type, callback) {
        this._adaptee.removeEventListener(type, callback);
    };
    URLLoader.prototype.addEventListener = function (type, callback) {
        _super.prototype.addEventListener.call(this, type, callback);
    };
    URLLoader.prototype.loadErrorDelegate = function (event) {
        if (event === void 0) { event = null; }
        this._dataIsNull = false;
        var newEvent = new this.sec.flash.events.IOErrorEvent(IOErrorEvent.IO_ERROR);
        newEvent.currentTarget = this;
        this.dispatchEvent(newEvent);
    };
    URLLoader.prototype.progressCallback = function (event) {
        if (event === void 0) { event = null; }
        this._dataIsNull = false;
        var newEvent = new this.sec.flash.events.
            ProgressEvent(ProgressEvent.PROGRESS, null, null, event.urlLoader.bytesLoaded, event.urlLoader.bytesTotal);
        newEvent.currentTarget = this;
        this.dispatchEvent(newEvent);
    };
    URLLoader.prototype.completeCallback = function (event) {
        if (event === void 0) { event = null; }
        this._dataIsNull = false;
        var newEvent = new this.sec.flash.events.Event(Event.COMPLETE);
        newEvent.currentTarget = this;
        newEvent.target = this;
        this.dispatchEvent(newEvent);
    };
    URLLoader.prototype.load = function (request) {
        var directUrl = request.url || '';
        var redirect = matchRedirect(directUrl, URLLoader.redirectRules);
        if (redirect) {
            console.log('[URL LOADER] Override loading url:', redirect.url);
            request.adaptee.url = redirect.url;
        }
        else {
            console.log('[URL LOADER] start loading the url:', directUrl);
        }
        // remap AS to JS before real request,
        // this is needed because some games fill data object after assigment
        request.mapToJSData();
        this._adaptee.load(request.adaptee);
    };
    URLLoader.redirectRules = [];
    return URLLoader;
}(EventDispatcher));
export { URLLoader };
